export function getAttributeName(name, aliases = {}) {
	if (aliases && aliases[name]) return aliases[name];
	return name;
}
export function getAliasHelper(aliases = {}) {
	return function(name) {
		return getAttributeName(name, aliases);
	}
}
